import React, { ReactElement } from 'react';
import { H4 } from '@xo-union/tk-ui-typography';
import styles from './styles.scss';

const SectionHeader = ({ children }: { children: React.ReactNode }): ReactElement => (
  <H4 className={styles.sectionHeader}>{children}</H4>
);

export default SectionHeader;
